export default defineNuxtRouteMiddleware((to, from) => {
    if (import.meta.server) return
    
    const { loggedIn } = useUserSession()
    
    if (loggedIn.value && to.path.match(/^\/braindate\/?$/)) {
        if (from.path === to.path) return
        return navigateTo({ 
            path: from.fullPath,
            hash: from.hash,
            query: { ...from.query, ...to.query, modal: to.path }
        })
    }
    
    if (!loggedIn.value && to.path.match(/^\/braindate\/?$/)) {
        if (from.path === to.path) return
        return navigateTo({ 
            path: from.fullPath,
            hash: from.hash,
            query: { ...from.query, ...to.query, modal: '/login', action: 'braindate' }
        })
    }

    if (to.path.match(/^\/speakers\/[^/]+$/)) {
        if (from.path === to.path || !from.name) return
        return navigateTo({
            path: from.fullPath,
            hash: from.hash,
            query: { ...from.query, ...to.query, drawer: to.path }
        })
    }

    if (to.path.match(/^\/sessions\/[^/]+$/)) {
        if (from.path === to.path || !from.name) return
        return navigateTo({
            path: from.fullPath,
            hash: from.hash,
            query: { ...from.query, ...to.query, drawer: to.path }
        })
    }

    if (to.path.match(/^\/reservations\/[^/]+$/)) {
        return navigateTo({ 
            path: from.fullPath,
            hash: from.hash,
            query: { ...from.query, ...to.query, modal: to.path }
        })
    }
    
    if (to.path.match(/^\/leave\/[^/]+$/)) {
        return navigateTo({ 
            path: from.fullPath,
            hash: from.hash,
            query: { ...from.query, ...to.query, modal: to.path }
        })
    }    

    // Schedule Builder. Same two-branch shape as braindate above: a logged-out
    // visitor gets the login modal instead, tagged with the action so the auth form
    // can send them on to /build-schedule once they're in.
    if (loggedIn.value && to.path.match(/^\/build-schedule\/?$/)) {
        if (from.path === to.path) return
        return navigateTo({
            path: from.fullPath,
            hash: from.hash,
            query: { ...from.query, ...to.query, modal: to.path }
        })
    }

    if (!loggedIn.value && to.path.match(/^\/build-schedule\/?$/)) {
        if (from.path === to.path) return
        return navigateTo({
            path: from.fullPath,
            hash: from.hash,
            query: { ...from.query, ...to.query, modal: '/login', action: 'schedule-builder' }
        })
    }

    // Login drops any open session drawer, unlike the other modal rewrites.
    //
    // The drawer and the modal are separate overlays, each with its own focus
    // trap. Stacking them leaves focus held by the DRAWER while the modal above
    // it is marked aria-hidden — so the login form renders, and cannot be typed
    // into: `input.focus()` simply does not take (Jack, 2026-08-20). Buttons
    // still work, because a click needs no focus, which is why this only shows up
    // on the one modal that asks for input.
    //
    // Dropping `drawer` closes the tray, so the login modal owns focus. The
    // visitor lands back on the page they came from rather than the session
    // tray — the alternative is a form they can see and cannot fill in.
    if (to.path.match(/^\/login\/?$/)) {
        const { drawer, ...keep } = from.query
        return navigateTo({
            path: from.fullPath,
            hash: from.hash,
            query: { ...keep, ...to.query, modal: to.path }
        })
    }

    if (to.path.match(/^\/search/)) {
        return navigateTo({
            path: from.fullPath,
            hash: from.hash,
            query: { ...from.query, ...to.query, modal: to.path }
        })
    }

    if (to.path.match(/^\/register-modal\/?$/)) {
        return navigateTo({
            path: from.fullPath,
            hash: from.hash,
            query: { ...from.query, ...to.query, modal: to.path }
        })
    }
})